import { Box, Chip, TextField, Typography } from '@mui/material';
import { useState } from 'react';
import { Dropzone } from '../Dropzone/Dropzone';

const Input = ({ data, input, setInputs, nd }: any) => {
  const findInput = input?.find(
    (inp: any) => inp?.inputId === data?.fullData?.selectedFlow,
  );

  const [text, setText] = useState(findInput?.inputText || '');

  const onInputChange = (e: any) => {
    const { name, value } = e.target;
    setText(value);

    setInputs((prev: any) =>
      prev?.map?.((inp: any) => {
        if (inp?.inputId === name) {
          return {
            ...inp,
            inputText: value,
          };
        }

        return inp;
      }),
    );
  };

  const isRequired = data.required === 'yes';

  return (
    <Box
      sx={{
        padding: '16px',
        borderRadius: data?.fullData?.borderRadius || '0px',
        height: 'fit-content',
        bgcolor: data?.fullData?.bgColor || '#fff',
        ...data?.style,
        display: 'flex',
        flexDirection: 'column',
        gap: '8px',
      }}
    >
      {isRequired && (
        <Chip
          label="Required"
          variant="filled"
          size="small"
          sx={{ maxWidth: 'fit-content', fontSize: '12px' }}
        />
      )}

      <Typography
        sx={{
          fontSize: '16px',
          fontWeight: '600',
          color: '#475467',
          ...data?.fullData?.titleStyle,
        }}
        variant="h1"
        mb={'8px'}
      >
        {data.label !== '' ? data.label : 'Title input'}
      </Typography>

      {data?.subtitle && (
        <Typography
          sx={{
            fontSize: '14px',
            fontWeight: '400',
            color: '#98A2B3',
            ...data?.fullData?.subtitleStyle,
          }}
          mb={'8px'}
          variant="h1"
        >
          {data?.subtitle ? data.subtitle : 'Title Component'}
        </Typography>
      )}

      {(data.ruleVarInputNode === 'text' ||
        data.ruleVarInputNode === 'both') && (
        <TextField
          fullWidth
          disabled={!findInput?.inputId}
          name={findInput?.inputId}
          multiline
          rows={Number(data?.fullData?.lineLength) || 3}
          value={text}
          onChange={onInputChange}
        />
      )}

      {(data.ruleVarInputNode === 'upload' ||
        data.ruleVarInputNode === 'both') && (
        <Dropzone data={data} nd={nd} input={input} setInputs={setInputs} />
      )}
    </Box>
  );
};

export default Input;
